import { Tooltip } from '../ui/tooltip'
import { Switch } from '../ui/switch'
import React from 'react'
import { Campaign } from '../../types/campaign'
import { ExtraType } from '../../types/table'
import { axiosPatch } from '../../util/api'
import { Toasts } from '../toaster/Toast'

interface SmartBidToggleProps {
    campaign: any
    extra: ExtraType
    disabled: boolean
}

export const SmartBidToggle = ({ campaign, extra, disabled }: SmartBidToggleProps) => {
    const hasActiveSubscription = extra?.hasActiveSubscription

    return (
        <Tooltip
            disabled={hasActiveSubscription}
            content={
                <div>Smart bid toggling is disabled until you have an active subscription</div>
            }
        >
            <Switch
                disabled={!hasActiveSubscription || disabled}
                className="mb-0"
                checked={campaign.smart_bid || false}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    toggleSmartBid(campaign.campaign_id, e.target.checked, extra)
                }
            />
        </Tooltip>
    )
}

const toggleSmartBid = (campaign_id: number, smart_bid: boolean, extra: ExtraType) => {
    extra.mutateItems((items: Campaign[]) =>
        items.map((i) => {
            if (i.campaign_id === campaign_id) {
                return {
                    ...i,
                    smart_bid,
                }
            } else {
                return i
            }
        }),
    )

    axiosPatch(`campaigns/${campaign_id}`, {
        smart_bid,
    }).then(() => {
        Toasts.success(`Smart bids ${smart_bid ? 'enabled' : 'disabled'}`)
    })
}
